import type { IColors } from "@swiggy-private/dls-web-common/dist/components/types.internal";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import styled from "styled-components";

export const Container = styled.div(({ theme }) => ({
    height: "100%",
    display: "flex",
    flexDirection: "column",
    background: theme.colors[theme.colorMode].canvas_Primary,
    overflowY: "scroll",
    width: "100%",
    position: "relative",
}));

export const PaymentOptionsContainer = styled.div(({ theme }) => ({
    padding: theme.spacing.large,
    paddingTop: theme.spacing.xLarge,
}));

export const PaymentCard = styled.div(({ theme }) => ({
    background: theme.colors[theme.colorMode].background_Primary,
    borderRadius: theme.cornerRadius.medium,
    padding: theme.spacing.medium,
    marginBottom: theme.spacing.x14,
    boxShadow: "0px 1px 16px rgba(0, 0, 0, 0.05)",
    border: `1px solid ${theme.colors[theme.colorMode].border_Tertiary}`,
}));

export const CardHeader = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.small,
    paddingBottom: theme.spacing.medium,
    marginBottom: theme.spacing.medium,
    borderBottom: `1px solid ${theme.colors[theme.colorMode].border_Tertiary}`,
}));

export const IconContainer = styled.div(() => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));

export const CardTitleContainer = styled.div(({ theme }) => ({
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.xxSmall,
}));

export const PriceText = styled(Text)<{ isStrikethrough?: boolean; isGreen?: boolean }>(
    ({ isStrikethrough, isGreen, theme }) => {
        let color = theme.colors[theme.colorMode].text_Highest_Emphasis;
        if (isGreen) {
            color = theme.colors[theme.colorMode].rating_Very_Good;
        } else if (isStrikethrough) {
            color = theme.colors[theme.colorMode].text_Low_Emphasis;
        }
        return {
            color,
            textDecoration: isStrikethrough ? "line-through" : "none",
            marginRight: theme.spacing.xxSmall,
            display: "inline",
        };
    }
);

export const OffersContainer = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.xxSmall,
    marginBottom: theme.spacing.medium,
}));

export const OfferItem = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.xxSmall,
}));

export const DotIcon = styled.div(({ theme }) => ({
    width: theme.spacing.xxSmall,
    height: theme.spacing.xxSmall,
    borderRadius: theme.cornerRadius.rounded,
    backgroundColor: theme.colors[theme.colorMode].text_Highest_Emphasis,
}));

export const OfferText = styled(Text)<{ colorToken?: keyof IColors }>(({ theme, colorToken }) => ({
    color: colorToken
        ? theme.colors[theme.colorMode][colorToken]
        : theme.colors[theme.colorMode].positive,
}));

export const MoreOffersText = styled(Text)(({ theme }) => ({
    color: theme.colors[theme.colorMode].text_High_Emphasis,
}));

export const ButtonContainer = styled.div({
    width: "100%",
});

export const DisclaimerMessage = styled(Text)(({ theme }) => ({
    color: theme.colors[theme.colorMode].text_Low_Emphasis,
    textAlign: "center",
    margin: `${theme.spacing.medium} ${theme.spacing.x18} 0 ${theme.spacing.x18}`,
}));

export const Separator = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: `${theme.spacing.x14} 0`,
    gap: theme.spacing.small,
    width: "100%",
}));

export const SeparatorLine = styled.div(({ theme }) => ({
    height: "1px",
    backgroundColor: theme.colors[theme.colorMode].border_Tertiary,
    width: "32px",
}));

export const SeparatorText = styled(Text)(({ theme }) => ({
    color: theme.colors[theme.colorMode].text_Low_Emphasis,
    textTransform: "uppercase",
}));

export const ErrorContainer = styled.div({
    display: "flex",
    margin: "110px auto",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    textAlign: "center",
    maxWidth: "320px",
});
